import {YesNo} from './master.entities.models';

export function compareById(item1: any, item2:any): boolean {
  return item1 && item2 ? item1.id === item2.id : item1 === item2;
}

export function compareYesNoBoolean(item1: YesNo, item2:boolean): boolean {
  return item1 && (item1.bool === item2);
}
